import ResourceList from "../components/ResourceList";

const ListResourcePage = () => {
  return (
    <ResourceList />
  );
};

export default ListResourcePage;
